export const environment = {
  production: false,

  clientName: 'demo',
  apiGatewayFront: 'https://siesaagp.inagromagdalena.com/',
  apiGatewayBackOffice: 'https://siesaagp.inagromagdalena.com/',
  apiUrl: 'https://siesaagp.inagromagdalena.com/',
  urlPath: 'https://siesaagp.inagromagdalena.com/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6Lf0Ox4mAAAAAOQ0hODeKEoGCNdVzoNDaI26M6tQ',

  googleAnalyticsCode: 'UA-140785247-1',
};